import reducer from "../reducerGenerator";

import * as actionTypes from "./actionTypes";
import * as reducerActions from "./reducerActions";

const initialState = {
  notice: null,
};

const mapper = {
  [actionTypes.NOTICE_FETCHED]: reducerActions.noticeFetched,
};

export default reducer(mapper, initialState);



// WEBPACK FOOTER //
// ./src/store/notices/reducer.js